import { render, staticRenderFns } from "./BaseTooltip.vue?vue&type=template&id=1f761884"
import script from "./BaseTooltip.vue?vue&type=script&lang=js"
export * from "./BaseTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports